import { render, staticRenderFns } from "./GlobalSearchBar.vue?vue&type=template&id=c66edd40&scoped=true&"
import script from "./GlobalSearchBar.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchBar.vue?vue&type=style&index=0&id=c66edd40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66edd40",
  null
  
)

export default component.exports